import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});



export default function Agent(props) {
  const classes = useStyles();
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Agent</TableCell>
            <TableCell>Open</TableCell>
            <TableCell align="right">Completed</TableCell>
            <TableCell align="right">Hourly Average (Day)</TableCell>
            <TableCell align="right">Hourly Average (Week)</TableCell>
            <TableCell align="right">Hourly Average (Month)</TableCell>
            <TableCell align="right">Hourly Average (All Time)</TableCell>
            <TableCell align="right">Nurturing</TableCell>
            <TableCell align="right">Contacted</TableCell>
            <TableCell align="right">Prospecting</TableCell>
            <TableCell align="right">Dead</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.rows.map((row) => (
            <TableRow key={row.agent_email}>
              <TableCell component="th" scope="row">
                {row.agent_email}
              </TableCell>
              <TableCell align="right">{row.open}</TableCell>
              <TableCell align="right">{row.completed}</TableCell>
              <TableCell align="right">{Math.round(row.day_total * 100 /row.day_hours) / 100}</TableCell>
              <TableCell align="right">{Math.round(row.week_total * 100 /row.week_hours) / 100}</TableCell>
              <TableCell align="right">{Math.round(row.month_total * 100 /row.month_hours) / 100}</TableCell>
              <TableCell align="right">{Math.round(row.all_time * 100 /row.all_time_hours) / 100}</TableCell>
              <TableCell align="right">{row.nurturing}</TableCell>
              <TableCell align="right">{row.contacted}</TableCell>
              <TableCell align="right">{row.prospecting}</TableCell>
              <TableCell align="right">{row.dead}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}



// WEBPACK FOOTER //
// ./src/components/TaskStatsView/agent.js